<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "app",
		data() {
			return {


			};
		},
		mounted() {





		},

		methods: {

		},
	};
</script>

<style lang="less">
</style>